import { ShareTo } from "../../config/Enums";
import { IShareSocialMediaItem } from "../../models/Interfaces";
import { SocialPublishingService } from "../socialpublishing/SocialPublishingService";
import { ISocialPublishResult } from "../socialpublishing/types";

export class SocialMediaPost {

  private _smPost: IShareSocialMediaItem | null;
  private readonly publishingService: SocialPublishingService;

  constructor() {
    this._smPost = null;
    this.publishingService = new SocialPublishingService();
  }

  public async shareVersionContent(shareditem: IShareSocialMediaItem, smType: ShareTo): Promise<ISocialPublishResult> {

    if (shareditem) {
      this._smPost = shareditem;

      return this.publishingService.shareVersionContent(shareditem, smType);
    }
    return { status: "failed" };
  }
}
